import { render, staticRenderFns } from "./CurrencySelectDropdown.vue?vue&type=template&id=bf9060be&scoped=true"
import script from "./CurrencySelectDropdown.vue?vue&type=script&lang=js"
export * from "./CurrencySelectDropdown.vue?vue&type=script&lang=js"
import style0 from "./CurrencySelectDropdown.vue?vue&type=style&index=0&id=bf9060be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9060be",
  null
  
)

export default component.exports